export const returnAnything = <T>(anything: T | T[] | undefined): T | undefined => {
  if (Array.isArray(anything)) {
    return anything[0];
  }

  return anything;
};
